import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClosedByteChannelExceptionClass;
function ClosedByteChannelException() {
  if (ClosedByteChannelExceptionClass === VOID) {
    class $ extends IOException() {
      constructor(cause) {
        return new.target.new_io_ktor_utils_io_ClosedByteChannelException_cg48aj_k$(cause);
      }
      static new_io_ktor_utils_io_ClosedByteChannelException_cg48aj_k$(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.new_kotlinx_io_IOException_pmronu_k$(cause == null ? null : cause.message, cause);
        captureStack($this, $this.$throwableCtor_3);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedByteChannelException', $.new_io_ktor_utils_io_ClosedByteChannelException_cg48aj_k$);
    ClosedByteChannelExceptionClass = $;
  }
  return ClosedByteChannelExceptionClass;
}
var ClosedReadChannelExceptionClass;
function ClosedReadChannelException() {
  if (ClosedReadChannelExceptionClass === VOID) {
    class $ extends ClosedByteChannelException() {
      constructor(cause) {
        return new.target.new_io_ktor_utils_io_ClosedReadChannelException_uqrd2v_k$(cause);
      }
      static new_io_ktor_utils_io_ClosedReadChannelException_uqrd2v_k$(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.new_io_ktor_utils_io_ClosedByteChannelException_cg48aj_k$(cause);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedReadChannelException', $.new_io_ktor_utils_io_ClosedReadChannelException_uqrd2v_k$);
    ClosedReadChannelExceptionClass = $;
  }
  return ClosedReadChannelExceptionClass;
}
var ClosedWriteChannelExceptionClass;
function ClosedWriteChannelException() {
  if (ClosedWriteChannelExceptionClass === VOID) {
    class $ extends ClosedByteChannelException() {
      constructor(cause) {
        return new.target.new_io_ktor_utils_io_ClosedWriteChannelException_h4pidy_k$(cause);
      }
      static new_io_ktor_utils_io_ClosedWriteChannelException_h4pidy_k$(cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.new_io_ktor_utils_io_ClosedByteChannelException_cg48aj_k$(cause);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedWriteChannelException', $.new_io_ktor_utils_io_ClosedWriteChannelException_h4pidy_k$);
    ClosedWriteChannelExceptionClass = $;
  }
  return ClosedWriteChannelExceptionClass;
}
//region block: exports
export {
  ClosedByteChannelException as ClosedByteChannelException3il8gfpye60w,
  ClosedReadChannelException as ClosedReadChannelException9jdpzh6uy12w,
  ClosedWriteChannelException as ClosedWriteChannelException1eeenxj0c4bxu,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
